import { useContext } from 'react';
import { onFocusContext } from './context';

export const useOnFocus = () => {
  const onFocus = useContext(onFocusContext);
  return onFocus;
};
